/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";
import { useParams } from "react-router-dom";
import ConundrumRemoteRenderer from "src/pods/conundrums/components/ConundrumRemoteRenderer";

export default function ConundrumStep() {
  const { mountPoint = "", classId = "", conundrumName = "", stepName = "" } = useParams();

  return (
    <ConundrumRemoteRenderer
      params={{
        mountPoint,
        classId,
        conundrumName,
        stepName,
      }}
    />
  );
}
